import React from 'react'
import Topbar from "./topBar";
import Sidebar from "./sideBar";
import { Link } from "react-router-dom";

const customerSupport = () => {
  return (
    <div id="wrapper">
      <Topbar backgroundColor="#0baae5" />
      <Sidebar />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <h4 className="page-title float-left">Customer Support</h4>
                  <ol className="breadcrumb float-right">
                    <li className="breadcrumb-item">
                      <Link to="/organisation/dashboard">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">Customer Support</li>
                  </ol>
                  <div className="clearfix"></div>
                  
                </div>
              </div>
            </div>

             
              <form>
                <div className="row">
                  <div className="col-12">
                    <div className="card-box">
                      <div className="row">
                        <div className="col-12">
                          <div className="p-20">
                          <div className="row">
              <div className="col-xs-12 col-md-6 col-lg-6 col-xl-4">
                <div className="card">
                  <div className="card-body">
                    <h4 className="text-dark font-18">Customer Support</h4>
                    <div className="row text-center justify-content-center align-items-center mt-3">
                      <img
                        src="/assets/images/joice.jpg"
                        alt=""
                        className="rounded-circle avatar-xxl"
                      />
                    </div>

                    <div className="row text-center justify-content-center align-items-center ">
                      <h4 className="text-dark font-18   mt-2 ">
                        Joice Mathew
                      </h4>
                    </div>
                    <div className="row text-center justify-content-center align-items-center ">
                      <h4 className=" font-16   ">kvkpta1995@gmail.com</h4>
                    </div>
                    <div className="row text-center justify-content-center align-items-center ">
                      <h4 className=" font-16">+91 91880 09623</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
           
        
          </div>
        </div>
      </div>
    </div>
  )
}

export default customerSupport